import { mergeBuyerRfqDraft, loadBuyerRfqDraft } from "@/lib/buyerRfqDraft";

/** Contact fields from a logged-in buyer account. */
export function buyerContactFromUser(user) {
  if (!user || user.role !== "buyer") return null;
  return {
    phone: String(user.phone || "").trim(),
    buyerName: String(user.name || "").trim(),
    company: String(user.company_name || "").trim(),
    city: String(user.default_city || "").trim(),
    pickupPoint: String(user.pickup_point || "").trim(),
  };
}

/** Merge saved draft with buyer profile (profile wins when set). */
export function mergeDraftWithBuyerProfile(draft, user) {
  const contact = buyerContactFromUser(user);
  if (!contact) return draft;
  return {
    ...draft,
    phone: contact.phone || draft.phone || "",
    buyerName: contact.buyerName || draft.buyerName || "",
    company: contact.company || draft.company || "",
    city: contact.city || draft.city || "",
  };
}

/** Persist buyer profile into the RFQ session draft for cross-page prefill. */
export function syncBuyerProfileToDraft(user) {
  const contact = buyerContactFromUser(user);
  if (!contact) return;
  const cur = loadBuyerRfqDraft();
  mergeBuyerRfqDraft({
    phone: contact.phone || cur?.phone || "",
    buyerName: contact.buyerName || cur?.buyerName || "",
    company: contact.company || cur?.company || "",
    city: contact.city || cur?.city || "",
  });
}

/** Resolve a single contact field: logged-in profile overrides empty draft values. */
export function resolveBuyerContactField(draftValue, profileValue, hasBuyerProfile) {
  const p = String(profileValue || "").trim();
  const d = String(draftValue ?? "").trim();
  if (hasBuyerProfile && p) return p;
  return d || p || "";
}
